export default __webpack_public_path__ + "assets/facebook-box.ecc647f7.svg";